import {
  Kind,
  InputValueDefinitionNode,
  InputObjectTypeDefinitionNode,
  BuildGraphQLArgumentProps,
  BuildGraphQLFieldProps,
  BuildGraphQLInputProps,
  BuildGraphQLObjectProps,
  NamedTypeNode,
  ListTypeNode,
  NonNullTypeNode,
  ObjectTypeDefinitionNode,
} from "@hotch/types";

import {
  NameNode,
  ObjectTypeExtensionNode,
  InputObjectTypeExtensionNode,
} from "graphql";

export const buildNameNode = (value: string): NameNode => {
  return {
    kind: Kind.NAME,
    value,
  };
};

export const buildNonNullableTypeNode = (
  type: NamedTypeNode | ListTypeNode
): NonNullTypeNode => {
  return {
    kind: Kind.NON_NULL_TYPE,
    type,
  };
};

export const buildListTypeNode = (
  type: NamedTypeNode | NonNullTypeNode
): ListTypeNode => {
  return {
    kind: Kind.LIST_TYPE,
    type,
  };
};

export const buildNamedTypeNode = (name: string): NamedTypeNode => {
  return {
    kind: Kind.NAMED_TYPE,
    name: buildNameNode(name),
  };
};

export const buildFieldDefinitionNode = (
  name: string,
  props: BuildGraphQLFieldProps
) => {
  return {
    kind: Kind.FIELD_DEFINITION,
    name: buildNameNode(name),
    ...props,
  };
};

export const buildObjectTypeNode = (
  name: string,
  props?: BuildGraphQLObjectProps
): ObjectTypeDefinitionNode => {
  return {
    kind: Kind.OBJECT_TYPE_DEFINITION,
    name: buildNameNode(name),
    ...props,
  };
};

export const buildInputTypeNode = (
  name: string,
  props: BuildGraphQLInputProps
): InputObjectTypeDefinitionNode => {
  return {
    kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
    fields: props.fields,
    name: buildNameNode(name),
  };
};

export const buildArgumentNode = (
  name: string,
  props: BuildGraphQLArgumentProps
): InputValueDefinitionNode => {
  return {
    kind: Kind.INPUT_VALUE_DEFINITION,
    type: props.type,
    name: buildNameNode(name),
  };
};

export const buildObjectExtensionNode = (
  name: string,
  props?: any
): ObjectTypeExtensionNode => {
  return {
    kind: Kind.OBJECT_TYPE_EXTENSION,
    name: {
      kind: Kind.NAME,
      value: name,
    },
    ...props,
  };
};

export const buildInputExtensionNode = (
  name: string,
  props?: any
): InputObjectTypeExtensionNode => {
  return {
    kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
    name: {
      kind: Kind.NAME,
      value: name,
    },
    ...props,
  };
};
